<template>
  <transition-group tag="ul" class="discovery -left" :style="{ height }" name="slide">
    <DiscoverySliderItem v-for="item in activeSlides" :key="item.title" v-bind="item" @report-height="registerHeight" />
    <button key="not-a-slide" class="discovery__link -next-slide" @click="next">{{ moreLabel }}</button>
  </transition-group>
</template>

<script>
import DiscoverySliderItem from './DiscoverySliderItem.vue'

export default {
  name: 'DiscoverySlider',
  components: { DiscoverySliderItem },
  props: {
    slides: { type: Array, default: Array }
  },
  data() {
    return {
      activeSlides: [],
      inactiveSlides: [],
      itemHeights: []
    }
  },
  computed: {
    height() {
      return !this.itemHeights.length ? 'auto' : `${Math.max(...this.itemHeights)}px`
    },
    moreLabel() {
      return this.$lang.current === 'en' ? 'See more' : 'Voir plus'
    }
  },
  watch: {
    slides: {
      immediate: true,
      handler(slides) {
        const slideCount = this.$device.tablet ? 2 : 1
        this.inactiveSlides = [...slides]
        this.activeSlides = this.inactiveSlides.splice(0, slideCount)
      }
    }
  },
  methods: {
    next() {
      this.inactiveSlides.push(this.activeSlides.shift())
      this.activeSlides.push(this.inactiveSlides.shift())
    },
    registerHeight(height) {
      const [prevHeight] = this.itemHeights
      this.itemHeights = [height, prevHeight]
    }
  }
}
</script>
